import React from 'react';
import { Alert } from 'reactstrap';
import DOMPurify from 'dompurify';
import Btn from '../Button';

const Alerts = (props) => {
  // Sanitize HTML content to prevent XSS attacks
  const sanitizedContent = props.btnContent ? DOMPurify.sanitize(props.btnContent) : '';

  return (
    <Alert {...props.attrAlert} >
      {props.children}
      {props.closeBtn ? (
        <Btn attrBtn={props.attrBtn}>
          <div className={props.divCls} dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
        </Btn>
      ) : ''}
    </Alert>
  );
};

export default Alerts;
